// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"8db4994e","191":"1e7ac1bf","281":"11bec51a","428":"44b9bb45","453":"f4d0d618"}[chunkId] + ".chunk.js";
};